import { useRouter } from 'next/router';
import Image from 'next/image';
import Banner from '../../images/banner-site.png';
import { Container } from '../common/Container';

export function Hero({ company_name, text, banner }) {
  const router = useRouter();

  return (
    <Container>
      <div className="relative opacity-90 rounded-[28px] bg-gradient-to-r from-primary to-transparent">
        <div className="absolute inset-0 z-10 rounded-[28px]" />
        <Image
          src={banner?.url || Banner}
          alt="Banner da Empressa"
          width={100}
          height={100}
          className="object-cover w-full min-h-[200px] rounded-[28px]"
          unoptimized
        />
        <div className="absolute inset-0 z-10 opacity-90 rounded-[28px] bg-gradient-to-r from-primary to-transparent" />
        <div className="absolute inset-0 z-20 flex items-center justify-center px-10 md:justify-start">
          <div className="max-w-lg py-3 text-center 2xl:max-w-2xl md:w-full md:text-left">
            <h1 className="mb-4 text-2xl font-light text-white font-helvetica md:text-3xl 2xl:text-5xl">
              {text ? text : `${company_name} - Venha fazer parte da nossa equipe!`}
            </h1>
            <div className="flex items-center justify-center mt-5 sm:mt-10 lg:mt-5 md:justify-start">
              <button
                onClick={() => {
                  router.push('#jobs');
                }}
                className="font-montserrat font-bold text-white bg-primary transition-all hover:scale-105 active:scale-95 hover:bg-secundary duration-300 px-4 sm:px-11 py-1 sm:py-2.5 lg:py-2.5 2xl:py-5 2xl:text-xl md:w-[350px] inline-block rounded-full"
              >
                Encontrar vagas!
              </button>
            </div>
          </div>
        </div>
      </div>
    </Container>
  );
}
